import { render, staticRenderFns } from "./TestRooRenderer.vue?vue&type=template&id=5dc33819&scoped=true"
import script from "./TestRooRenderer.vue?vue&type=script&lang=js"
export * from "./TestRooRenderer.vue?vue&type=script&lang=js"
import style0 from "./TestRooRenderer.vue?vue&type=style&index=0&id=5dc33819&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc33819",
  null
  
)

export default component.exports